import { cn } from "@/lib/class-control";
import { Button } from "./button";

interface TabsUnderlineProps {
  tabs: string[];
  activeTab: string;
  classes?: {
    button?: string
    text?: string;
  }
  onTabChange: (tab: string) => void;
}

export function TabsUnderline({ tabs, activeTab, classes, onTabChange }: TabsUnderlineProps) {
  const activeIndex = Math.max(0, tabs.indexOf(activeTab));
  const widthPercent = 100 / tabs.length;
  const translatePercent = activeIndex * 100;

  return (
    <div className="relative flex items-start w-full">
      <span
        aria-hidden
        className="pointer-events-none absolute bottom-0 left-0 h-0.5 bg-purple-500 transition-transform duration-300 ease-out"
        style={{ width: `${widthPercent}%`, transform: `translateX(${translatePercent}%)` }}
      />
      {tabs.map((tab) => {
        const isActive = tab === activeTab;

        return (
          <Button
            key={tab}
            size="lg"
            variant="ghost"
            onClick={() => onTabChange(tab)}
            className={cn(
              "flex-1 rounded-none",
              classes?.button
            )}
          >
            <span
              className={cn(
                "text-base leading-normal text-gray-500 font-normal hover:text-gray-400",
                "transition-colors duration-200 ease-in-out",
                isActive && "text-white font-bold",
                classes?.text
              )}
            >
              {tab}
            </span>
          </Button>
        );
      })}
    </div>
  );
}
